import React, { Fragment } from 'react';
import { withStyles } from 'tss-react/mui';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import educatorPassportLogo from '../../images/educator-passport.png';
import FlashMessages from '../../common/components/misc/FlashMessages';
import LoginLayout from './LoginLayout';

const styles = theme => ({
  backToLoginLink: {
    color: theme.typography.color.primary,
    '&:hover': {
      color: theme.typography.color.primary,
    },
    '&:visited': {
      color: theme.typography.color.primary,
    },
    fontSize: theme.typography.pxToRem(13),
    marginLeft: theme.typography.pxToRem(20),
  },
  loginActions: {
    marginTop: theme.typography.pxToRem(40),
  },
  loginHeader: {
    marginBottom: theme.typography.pxToRem(20),
  },
  loginLogo: {
    marginBottom: theme.typography.pxToRem(30),
  },
});

class ForgotPasswordForm extends React.Component {

  render() {
    const { classes, validationErrors } = this.props;

    return (
      <Fragment>
        <div className={classes.loginLogo}>
          <img src={educatorPassportLogo} />
        </div>
        <Typography className={classes.loginHeader} variant="h6">
          Forgot Password
        </Typography>
        <FlashMessages flashMessages={this.props.flashMessages}/>
        <form action="/users/password" method="post">
          <input name="authenticity_token" type="hidden" value={this.props.csrf} />
          <input name="is_admin_app" type="hidden" value="true" />
          <TextField
            variant="standard"
            autoFocus
            fullWidth
            error={validationErrors.hasOwnProperty('email')}
            helperText={validationErrors.hasOwnProperty('email') && validationErrors['email'][0]}
            id="email"
            label="Email"
            name="user[email]"
            type="email" />
          <Grid
            container
            alignItems="center"
            className={classes.loginActions}
          >
            <Button color="primary" type="submit" variant="contained">
              Reset Password
            </Button>
            <a
              className={classes.backToLoginLink}
              data-turbolinks="false"
              href="/users/sign_in"
            >
              Back to Login
            </a>
          </Grid>
        </form>
      </Fragment>
    );
  }

};

const StyledForgotPasswordForm = withStyles(ForgotPasswordForm, styles, { withTheme: true });
const ForgotPasswordApp = (props) => {
  return (<LoginLayout><StyledForgotPasswordForm {...props}/></LoginLayout>);
};

export default ForgotPasswordApp;
